import { SESSION_ID } from '../../../../config/session-id';
import { Captcha } from '../../../components/captcha/captcha.model';
import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(
        $scope,
        $state,
        AuthenticationSharedService,
        CompanyRegistration,
        RegistrationCodeGeneratonService,
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.AuthenticationSharedService = AuthenticationSharedService;
        this.CompanyRegistration = CompanyRegistration;
        this.RegistrationCodeGeneratonService = RegistrationCodeGeneratonService;
    }

    $onInit() {
        this.companyName = '';
        this.email = '';
        this.showCaptcha = false;
        this.captcha = new Captcha({isVisible: () => this.showCaptcha});

        this.$scope.$on('websocket.REGISTERED_COMPANY', (event, data) => {
            const {username, password, company} = data;
            this.AuthenticationSharedService
                .loginAfterRegistration({username, password, companyId: company.id});
        });
    }

    loadQrData() {
        return this.RegistrationCodeGeneratonService
            .get({uuid: SESSION_ID}).$promise
            .then(barcode => {
                this.showCaptcha = barcode.showCaptcha;
                return barcode.barcodeimage;
            });
    }

    register() {
        this.CompanyRegistration
            .save({
                companyName: this.companyName,
                email: this.email,
                captchaResponse: this.captcha.response
            })
            .$promise
            .then(
                () => this.$state.go('public.company-registration-success'),
                ({status, data}) => {
                    if (status === 412) {
                        const key = 'registration.company.messages.invalid_captcha';
                        this.spAlert = new SpAlert('danger', key);
                    } else {
                        this.spAlert = new SpAlert('danger', data.message, {}, false);
                    }
                    this.captcha.reset();
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/company-registration/company-registration.controller.js